<template>
    <div class="header__account-item header__account--basket">
        <a class="h-link" :href="link">
            <span v-if="count > 0">{{count}}</span>
        </a>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "BasketMobile",
    props: ['link'],
    computed: {
        ...mapState([
            'moduleBasket'
        ]),
        count () {
            if(this.moduleBasket.basket)
                return Object.keys(this.moduleBasket.basket).length;
            else
                return 0;
        },
    },
}
</script>

<style scoped>

</style>